import { Box, Button, TextField } from '@mui/material';
import AddIcon from '@mui/icons-material/Add';

export const FilteringBlock = ({ userRole, handleShowAdd, lngsltd, search, setSearch, handleClearFilters }) => {
    return (
        <Box
            display="flex"
            flexDirection={{ xs: 'column', md: 'row' }}
            alignItems={{ xs: 'stretch', md: 'center' }}
            gap={{ xs: 1.5, md: 2 }}
            width="100%"
        >
            <TextField
                size="small"
                fullWidth
                variant="outlined"
                placeholder={lngsltd["Search by CourseName"]}
                value={search}
                onChange={(e) => setSearch(e.target.value)}
                sx={{
                    flex: { md: 2 },
                    minWidth: { md: '200px' },
                }}
            />

            <Box 
                display="flex" 
                flexDirection={{ xs: 'column', sm: 'row' }}
                gap={{ xs: 1.5, sm: 2 }}
                width={{ xs: '100%', md: 'auto' }}
            >
                <Button
                    variant="outlined"
                    color="error"
                    fullWidth
                    onClick={handleClearFilters}
                    sx={{
                        minWidth: { sm: '150px' },
                        fontSize: "12px",
                        whiteSpace: 'nowrap',
                    }}
                >
                    {lngsltd["Clear Filters"]}
                </Button>

                {userRole === 'Admin' && (
                    <Button
                        variant="contained"
                        color="primary"
                        fullWidth
                        onClick={() => handleShowAdd()}
                        startIcon={<AddIcon />}
                        sx={{
                            minWidth: { sm: '150px' },
                            whiteSpace: 'nowrap',
                        }}
                    >
                        {lngsltd["Add Course"]}
                    </Button>
                )}
            </Box>
        </Box>
    );
};
